import { memo, useMemo } from 'react'
import StopIcon from '@mui/icons-material/Stop'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import BaseNode from './BaseNode'
import { WorkflowNodeData } from '@store/workflowStore'
import { WorkflowNodeType } from '@features/adventures/types/workflow.types'

interface ExitNodeProps {
  id: string
  data: WorkflowNodeData
  selected?: boolean
}

function ExitNode(props: ExitNodeProps) {
  const icon = useMemo(() => {
    switch (props.data.nodeType) {
      case WorkflowNodeType.ExitSuccess:
        return <CheckCircleIcon fontSize="small" />
      case WorkflowNodeType.ExitFailed:
        return <CancelIcon fontSize="small" />
      case WorkflowNodeType.ExitAbandoned:
        return <ExitToAppIcon fontSize="small" />
      case WorkflowNodeType.Exit:
      default:
        return <StopIcon fontSize="small" />
    }
  }, [props.data.nodeType])

  return (
    <BaseNode
      {...props}
      icon={icon}
      showTargetHandle={true}
      showSourceHandle={false}
    />
  )
}

export default memo(ExitNode)
